'use client'

import { IconSearch } from '@macarongfactory/web-icons'
import Link from 'next/link'

import { OptimizedImage } from '@/shared/ui'

import heroCar from '../_assets/hero-car.png'
import {
  CAR_SEARCH_PATH,
  HOME_COPY,
  HOME_TRACK_CODE,
  HOME_TRACK_LABEL,
  HOME_TRACK_TYPE,
  useHomeImpression,
  useHomeTracking,
} from '../_features/modoocar-home'

const HERO_BACKGROUND =
  'linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 175, 255, 0.15) 100%), #FFFFFF'

const SEARCH_ICON_SIZE_PX = 20

const HomeHero = () => {
  const { sectionShow, itemClick } = useHomeTracking()

  const sectionRef = useHomeImpression<HTMLElement>(() =>
    sectionShow(HOME_TRACK_CODE.HERO, HOME_TRACK_LABEL.HERO_SECTION)
  )

  return (
    <section
      ref={sectionRef}
      className='relative flex flex-col gap-dimension-x8 px-dimension-x10 pb-dimension-x8 pt-dimension-x16 max-[639px]:px-dimension-x5'
      style={{ background: HERO_BACKGROUND }}
    >
      <div className='flex flex-col gap-dimension-x6'>
        <h1 className='text-[36px] font-bold leading-[48px] text-[#1A2128] max-[639px]:text-[26px] max-[639px]:leading-[35px]'>
          <span className='block text-[#00AFFF]'>
            {HOME_COPY.heroHighlight}
          </span>
          <span className='block'>{HOME_COPY.heroLine1}</span>
          <span className='block'>{HOME_COPY.heroLine2}</span>
        </h1>

        <Link
          href={CAR_SEARCH_PATH}
          className='flex items-stretch gap-[8px]'
          onClick={() =>
            itemClick(
              HOME_TRACK_CODE.HERO,
              HOME_TRACK_TYPE.SEARCH_BAR,
              HOME_TRACK_LABEL.HERO_SEARCH
            )
          }
        >
          <div className='flex min-w-0 flex-1 items-center gap-dimension-x2 self-stretch overflow-hidden rounded-dimension-x3 border-2 border-stroke-brand-strong bg-background-surface-default px-dimension-x3 py-dimension-x2'>
            <span className='shrink-0 text-foreground-neutral-assistive'>
              <IconSearch
                width={SEARCH_ICON_SIZE_PX}
                height={SEARCH_ICON_SIZE_PX}
              />
            </span>
            <span className='text-title-1-medium text-foreground-neutral-assistive'>
              {HOME_COPY.searchPlaceholder}
            </span>
          </div>
          <div className='flex h-dimension-x12 min-w-[72px] shrink-0 items-center justify-center rounded-dimension-x3 bg-background-brand-strong px-dimension-x5'>
            <span className='text-title-1-semibold text-foreground-static-white'>
              {HOME_COPY.searchButton}
            </span>
          </div>
        </Link>
      </div>

      <div
        aria-hidden
        className='pointer-events-none absolute right-dimension-x10 top-[72px] w-dimension-x40 max-[639px]:right-dimension-x5 max-[639px]:top-[93px] max-[639px]:w-dimension-x25'
      >
        <OptimizedImage
          src={heroCar}
          alt=''
          width='100%'
          height='auto'
          radius={0}
          sizes='160px'
          loading='eager'
          fetchPriority='high'
          style={{ aspectRatio: `auto ${heroCar.width} / ${heroCar.height}` }}
        />
      </div>
    </section>
  )
}

export default HomeHero
